<template>
  <div class="gamehistory">
    <v-container class="pt-0">
      <span class="headline">{{$t('publicGames.title')}}</span>
      <v-toolbar dense>
        <v-spacer></v-spacer>
        <v-icon color="primary" border>mdi-filter</v-icon>
        <v-btn-toggle
          style="margin-right:-8px"
          v-model="matchOwnPlatforms"
          dense
          color="primary"
          mandatory
        >
          <v-btn :value="true">{{$t('common.own-platforms')}}</v-btn>
          <v-btn :value="false">{{$t('common.all')}}</v-btn>
        </v-btn-toggle>
      </v-toolbar>
      <v-tabs v-model="tab" class="tabWithoutSlideIndicator">
        <v-tab :key="'official'" :href="`#official`">{{$t('publicGames.official')}}</v-tab>
        <v-tab v-if="canCreateNewGames" :key="'usercups'" :href="`#usercups`">{{$t('publicGames.user-cups')}}</v-tab>
      </v-tabs>
      <game-list-public :games="this.gamesFiltered" :loading="loading"/>
    </v-container>
  </div>
</template>

<script>
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import { MUTATION_SET_UI_OPTION } from "@/plugins/store";
import platformMixins from "@/mixins/platformMixins";
import gameTypeMixin from "@/mixins/gameTypeMixin";
import GameListPublic from "@/widgets/GameListPublic";
import envMixin from "@/mixins/envMixin";

export default {
  name: "PublicGames",
  components: {GameListPublic},
  props: {},
  mixins: [platformMixins, gameTypeMixin, envMixin],
  data: function() {
    let matchOwnPlatforms = this.$store.state.ui.options['PublicGames_matchOwnPlatform'] == true;
    let tab = this.$route.query.tab;
    tab = (tab ? tab : 'official');
    return {
      loading: false,
      tab: tab,
      games: undefined,
      matchOwnPlatforms: matchOwnPlatforms,
    };
  },
  computed: {
    gamesFiltered: function() {
      if (!this.games) {
        return undefined
      }
      let ret = this.games.filter((game) => {
        var allow = true
        if (this.matchOwnPlatforms) {
          let userPlatforms = this.$store.state.profile.platforms
          if (!userPlatforms.find((platform) => {
            return platform.platform_code == game.platform
          })) {
            allow = false;
          }
        }
        return allow
      })
      return ret
    },
    canCreateNewGames() {
      return this.envGetUserKey('permission.createGames') == true;
    },
  },
  watch: {
    matchOwnPlatforms: function(val) {
      this.$store.commit(MUTATION_SET_UI_OPTION, {key: 'PublicGames_matchOwnPlatform', value: val});
    },
    tab: function(key) {
      if (this.$route.query.tab != key) {
        if (key == 'official') {
          key = undefined;
        }
        this.$router.replace({ query: { ...this.$route.query, tab: key } }).catch(() => {
        // Ignore NavigationDuplicated
        });
      }
      this.refreshTable();
    }
  },
  mounted() {
    this.refreshTable();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  methods: {
    onRefreshData() {
      this.refreshTable();
    },
    refreshTable() {
      this.loading = true;
      if (this.tab == 'official') {
        this.$api
          .getPublicGames()
          .then(response => {
            this.loading = false;
            let list = response.data.list;
            this.games = list;
          })
          .catch(error => {
            this.loading = false;
            this.$common.onError(error)
          });
      } else {
          this.$api
          .getPublicUsercups()
          .then(response => {
            this.loading = false;
            let list = response.data.list;
            this.games = list;
          })
          .catch(error => {
            this.loading = false;
            this.$common.onError(error)
          });
      }
    },
  }
};
</script>

<style scoped>
.tabWithoutSlideIndicator >>> .v-slide-group__prev {
  display: none !important;
}
</style>
